// @flow
import type { State } from "@store/reducers";
import type { StaffGroupsState } from "@modules/shared/reducer/staff-groups/types";
import type { StaffGroup } from "@modules/service/reducer/staff-groups/types";

export type GetSharedStaffGroups = (state: State) => StaffGroupsState;
export const getSharedStaffGroups = (state: Object): GetSharedStaffGroups =>
  state.shared.staffGroups;

export type GetClientStaffGroups = (state: State) => Array<StaffGroup>;
export const getClientStaffGroups = (state: State): GetClientStaffGroups =>
  getSharedStaffGroups(state).list.content;

export const getStaffGroupsLabels = (state: State, staffGroupIdList: Array<number>): string => {
  const staffGroups = getClientStaffGroups(state);
  return staffGroupIdList
    .reduce((acc, staffGroupId) => {
      const existingStaffGroup = staffGroups.find(staffGroup => staffGroup.id === staffGroupId);

      if (existingStaffGroup) {
        return [...acc, existingStaffGroup.name];
      }

      return acc;
    }, [])
    .join(", ");
};
